var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTripScheduler(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6294_267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1591 16.125H27.3636V11.825H15.6364V4.8375L7.81818 0L0 4.8375V14.5125L1.95455 15.7229V33.325H27.3636H43V29.025L36.1591 16.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2727 26.8719H41.7569L38.44 20.4219L31.2727 26.8719Z",
    fill: "#CCE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2726 33.325V16.125H27.3636V33.325H1.95447V37.625H9.77265V40.85L12.7045 43L15.6363 40.85V37.625H31.2726V40.85L34.2045 43L37.1363 40.85V37.625H42.9999V33.325H31.2726Z",
    fill: "#CCE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6364 4.83984V14.5148L7.81818 19.3523L0 14.5148L15.6364 4.83984Z",
    fill: "#CCE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77271 40.8477L12.7045 42.9977L15.6363 40.8477V37.6227L12.7045 35.4727L9.77271 37.6227V40.8477Z",
    stroke: "#1078FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2727 40.8477L34.2045 42.9977L37.1363 40.8477V37.6227L34.2045 35.4727L31.2727 37.6227V40.8477Z",
    stroke: "#1078FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.95447 22.5781V33.3281H27.3636V11.8281H19.5454",
    stroke: "#1078FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0456 37.625H43.0001V33.325V29.025L36.1592 16.125H27.3638",
    stroke: "#1078FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.44 20.4219H31.2727V26.8719H41.7569",
    stroke: "#1078FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0001 33.3281H27.3638",
    stroke: "#1078FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3637 37.625H19.5455",
    stroke: "#1078FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86356 37.625H1.95447",
    stroke: "#1078FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81824 5.375V11.825H11.7273",
    stroke: "#1078FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6364 14.5125L7.81818 19.35L0 14.5125V4.8375L7.81818 0L15.6364 4.8375V14.5125Z",
    stroke: "#1078FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6294_267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripScheduler);
export default __webpack_public_path__ + "static/media/trip-scheduler.66c67b6bf88712d659510956d84bfa3a.svg";
export { ForwardRef as ReactComponent };